var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "create-button" }, [
    _c(
      "div",
      {
        staticClass: "fab d-flex justify-content-center align-items-center",
        on: {
          click: function ($event) {
            return _vm.$emit("click")
          },
        },
      },
      [_c("md-icon", {}, [_vm._v("add")])],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }